import { Card } from '../ui'

/**
 * The baseline as one ring (Sprint 1.9.9, R37, R50).
 *
 * Confirmed is a closed ring, held low an open one, and none an empty track —
 * three states, with no fraction drawn: how many days make a baseline is
 * backend configuration, and a ring filled "2 of 3" would be the client
 * writing that number down. The words are R37's ("Confirmed", "Held low"),
 * handed in finished from `Home.tsx`, with eyes open on its own line.
 */
export function BaselineRing({
  state,
  condition,
  title,
  detail,
  other,
  device,
}: {
  state: 'confirmed' | 'held' | 'none'
  /** "Eyes closed". */
  condition: string
  title: string
  detail: string | null
  /** Eyes open, in one line. */
  other: string
  device: string
}) {
  return (
    <Card as="article" eyebrow="Your baseline" meta={device} className="bring" data-testid="home-baseline">
      <div className="bring__row">
        <svg className={`bring__ring bring__ring--${state}`} viewBox="0 0 48 48" aria-hidden="true">
          <circle className="bring__track" cx="24" cy="24" r="20" />
          {state !== 'none' && <circle className="bring__arc" cx="24" cy="24" r="20" />}
          {state === 'confirmed' && <path className="bring__check" d="M17 25l5 5 9-10" />}
        </svg>
        <div className="bring__text">
          {/* A paragraph, not a heading: the card's eyebrow names it, and a
              state word as an h3 straight under the page's h1 skipped a level. */}
          <p className="bring__title">{title}</p>
          <p className="bring__detail">{detail === null ? condition : `${condition} · ${detail}`}</p>
        </div>
      </div>
      <p className="bring__other">{other}</p>
    </Card>
  )
}
